var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/~/lodash/_getPrototype.js
// module id = 207
// module chunks = 0